import { ChangeDetectionStrategy, Component, ElementRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { filter, pairwise } from 'rxjs';

import { BookingAppState } from '@fcom/common/interfaces/booking/booking-state.interface';
import { LoginStatus } from '@fcom/core-api/login/interfaces/login.interface';
import { loginStatusSelector, selectProfileOrUndefinedIfNotLoggedIn } from '@fcom/core/selectors/login.selector';
import { ScrollService } from '@fcom/common/services/scroll/scroll.service';

@Component({
  selector: 'fin-login-promotion',
  templateUrl: './login-promotion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginPromotionComponent {
  private store = inject<Store<BookingAppState>>(Store);
  private elementRef = inject(ElementRef);
  private scrollService = inject(ScrollService);

  showGreeting = input(true);

  isMultiPax = input(false);

  readonly loggedInProfile = this.store.selectSignal(selectProfileOrUndefinedIfNotLoggedIn);
  readonly loginStatus = this.store.selectSignal(loginStatusSelector);

  readonly LoginStatus = LoginStatus;

  constructor() {
    this.store
      .select(loginStatusSelector)
      .pipe(
        pairwise(),
        filter(([prev, current]) => {
          // only do the scroll when the login is done on this page, do not scroll when the user logged in on a previous step. pending > logged_in is how to detect this.
          return prev === LoginStatus.PENDING && current === LoginStatus.LOGGED_IN;
        }),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        this.scrollService.smoothScroll(this.elementRef, { offsetY: 60 });
      });
  }
}
